import { render, staticRenderFns } from "./AddToInvoice.vue?vue&type=template&id=156b1d64&"
import script from "./AddToInvoice.vue?vue&type=script&lang=js&"
export * from "./AddToInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddToInvoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports